import { makeStyles } from '@material-ui/core'

export const useFormStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
  },
  submit: {
    width: '100%',
    paddingTop: 8,
    paddingBottom: 8,
    marginTop: 26,
    textTransform: 'initial',
  },
  border: {
    width: '60%',
    border: `1px solid ${theme.palette.secondary.light}`,
    marginBottom: 24,
    margin: 'auto',
  },
  borderSeparator: {
    width: '60%',
    border: `1px solid ${theme.palette.secondary.light}`,
    margin: 'auto',
    marginBottom: 24,
    marginTop: 24,
  },
  smallMarginLabel: {
    marginBottom: 16,
  },
  submitMargin: {
    marginTop: 26,
  },
}))
